import { useEffect } from 'react';
import BodyClass from '@plone/volto/helpers/BodyClass/BodyClass';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { Container } from 'semantic-ui-react';
import {
  toBackendLang,
  withServerErrorCode,
} from '@plone/volto/helpers/Utils/Utils';
import { useDispatch, useSelector } from 'react-redux';
import { getNavigation } from '@plone/volto/actions/navigation/navigation';
import config from '@plone/volto/registry';
import { messages } from '../../../../index';
import { getVar } from '../../../../helpers/utils';

const NotFound = () => {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.intl.locale);
  const location = useLocation();
  const intl = useIntl();

  useEffect(() => {
    dispatch(
      getNavigation(
        config.settings.isMultilingual ? `/${toBackendLang(lang)}` : '/',
        config.settings.navDepth,
      ),
    );
  }, [dispatch, lang]);

  const legacyUrl = getVar('RAZZLE_LEGACY_URL');

  return (
    <Container className="view-wrapper" style={{ padding: '1em' }}>
      <BodyClass className="page-not-found" />
      <h1>
        <FormattedMessage
          id="This page does not seem to exist..."
          defaultMessage="This page does not seem to exist..."
        />
      </h1>
      {legacyUrl && (
        <p>
          <strong>{intl.formatMessage(messages.legacySearchText)}</strong>
          <br />
          <a
            style={{ display: 'block', paddingTop: '1em' }}
            href={`${legacyUrl}${location.pathname}`}
          >{`${legacyUrl}${location.pathname}`}</a>
        </p>
      )}
      <p>
        {intl.formatMessage(messages.ifYouAreCertain)}{' '}
        <a href="https://help.jyu.fi">
          {intl.formatMessage(messages.contactUs)}
        </a>
      </p>
      <p>
        <FormattedMessage id="Thank you." defaultMessage="Thank you." />
      </p>
    </Container>
  );
};

export default withServerErrorCode(404)(NotFound);
